<template>
    <div class="auth-wrapper auth-v2">
        <div class="w-100 d-flex flex-column justify-content-between">
            <div class="px-2">
                <HeaderBar/>
                <div
                class="d-flex flex-column mb-2 mt-4"
                style="font-size: 15px; font-weight: 500"
                >
                    <div class="add-economic-record-title1 mt-2 text-center">
                        Cargar datos Aborto
                    </div>
                </div>
                <validation-observer ref="GanForm">
                    <b-form @submit.prevent="">
                        <b-form-group label="Fecha" 
                        label-for="fecha_compra">
                            <validationProvider
                                #default="{ errors }"
                                name="Fecha"
                                rules="required"
                            >
                                <b-form-datepicker id="fecha_compra" name="fecha_compra" v-model="reproductive.date" 
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                :min="minCfgDate" :max="maxCfgDate"
                                locale="es-ES"/>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validationProvider>
                        </b-form-group>
                        <b-form-group label="Seleccionar Vaca (hembras)" label-for="selFemale" class="selFemale">
                            <validation-provider #default="{ errors }" name="Vaca" rules="required">
                                <b-form-select id="selFemale" v-model="reproductive.animal_id" :options="animalsOptionsFem" :values="animalsOptionsFem.value" label="text" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group  label="Detalle" label-for="Exam">
                            <validation-provider #default="{ errors }" name="Detalle" rules="required">
                                <b-form-textarea id="textarea" v-model="reproductive.details"  rows="5"></b-form-textarea>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-form>
                </validation-observer>
                <div class="additive">
                    <b-form-group>
                        <div class="d-flex justify-content-center">
                            <b-button type="submit" v-on:click="insertReproductive"
                                class="bg-primary dataButton mt-1 d-flex align-items-center justify-content-center">
                                <div class="ml-5 mr-5"> Incluir Evento </div>
                            </b-button>
                        </div>
                    </b-form-group>
                </div>
                <ControlMenu />
            </div>
        </div>
    </div>
</template>

<script>
import HeaderBar from '@/components/HeaderBar.vue'
import ControlMenu from '@/components/ControlMenu.vue'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BFormTextarea,BFormDatepicker,BFormSelect, BFormGroup, BFormInput, BForm, BImg, BButton, BFormCheckbox } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        ControlMenu,
        HeaderBar,
        flatPickr,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BFormInput,
        BFormDatepicker,
        BFormSelect,
        BForm,
        required,
        vSelect,
        BImg,
        BButton,
        BFormCheckbox,
        BFormTextarea,
    },
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 119)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate())
        return {
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            animal_picker_female: null,
            animalsOptionsFem:[],
            reproductive:{
                farm_id: localStorage.getItem('currentFarm'),
                status:1,
                date: today,
                condition_id:1,
                type:5,
                animal_id:0,
                days:0,
                male_id:59,
                details:'',
            }
        }
    },
    methods:{
        async fetchAnimalsFem(config){
            let farmId= localStorage.getItem('currentFarm');
            fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&sex=1&pregnant=1&state=1", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.animals);
                this.animalsOptionsFem = result.animals.map(item => {return {value:item.id,text:item.number+ ' '+item.name}})
            })
        },
        insertReproductive(){
            let self=this;
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            //this.reproductive.animal_id=this.animal_picker_female.value;
            this.reproductive.male_id=this.reproductive.animal_id;
            console.log(this.reproductive);
            this.$refs.GanForm.validate().then(success => { 
                if(success){
                    this.$http.post("add/reproductive_records", this.reproductive, config).then(() => {
                        self.$http.post("edit/animals/"+self.reproductive.animal_id, 
                        {
                            pregnant:0
                        },config);
                        this.reproductive={
                            status:1,
                            date:null,
                            condition_id:1,
                            type:5,
                            animal_id:0,
                            days:0,
                            male_id:0,
                            details:'',
                        }
                        this.$swal({
                            title: 'Registro reproductivo',
                            text: 'Se insertó registro de aborto de manera satisfactoria',
                            type: 'success',
                            icon:'success',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            history.back();
                        });
                    }).catch(error => {
                        console.log(error)
                    });
                }
            })
        }
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchAnimalsFem(config);
    }
}
</script>
    
<style lang="scss">

@import '@core/scss/vue/pages/page-auth.scss';
</style>